import { useQuery } from '@tanstack/react-query';
import { apiGet, operationsClient } from '@/lib/api/client';

export interface CustomerCommsHold {
  held: boolean;
  changedAt: string | null;
}

/**
 * Whether this account's customer communications are on hold (set by Notifi
 * support during onboarding). Refreshed every minute so a lifted hold clears
 * the banner without a reload.
 */
export function useCustomerCommsHold() {
  return useQuery<CustomerCommsHold>({
    queryKey: ['messaging', 'customer-communications-hold'],
    queryFn: () =>
      apiGet<CustomerCommsHold>(operationsClient, '/messaging/customer-communications-hold'),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
